module.exports = __webpack_public_path__ + "static/media/galway.43272258.png";